<div class="divider divider-horizontal">This is a footer</div>
